let hasHeadersErrorBeenReported = false;

export function reportHeadersErrorOne(): void {
  if (hasHeadersErrorBeenReported) return;
  console.error("Can't read api version in the response headers");
  hasHeadersErrorBeenReported = true;
}
